import PhotoList from "./PhotoList";

function App({ handleLogout }) {
  return <PhotoList handleLogout={handleLogout} />;
}

export default App;
